export const TOKEN_STORAGE_KEY = 'chianti_token';
export const REMENBER_PASSWORD_SWITCH_STORAGE_KEY = 'remember_password';

export const TAG_TYPE = {
  male: 'success',
  female: 'warning',
  unknown: 'info',
  init: 'info',
  completed: 'success',
  applied: 'warning',
  refunding: 'danger',
  cancelled: 'info',
  closed: 'info',
  pending: 'warning',
  shipped: '',
  received: 'success',
  draft: 'info',
  published: 'success',
  success: 'success',
  fail: 'danger',
  delay: 'pending'
}

export const GENDER = {
  male: '男',
  female: '女',
  unknown: '未知'
}

export const TAXONOMY_TYPE = {
  category: '分类'
}

export const ORDER_STATE = {
  init: '待支付',
  completed: '已支付',
  applied: '申请退款',
  refunding: '退款中',
  cancelled: '已退款',
  closed: '已关闭'
}

export const ORDER_SHIPMENT_STATE = {
  init: '初始',
  pending: '待发货',
  shipped: '已发货',
  canclled: '已取消',
  received: '已确认收货'
}

export const PAGE_TYPE = {
  StaticPage: '静态页面',
  PresetPage: '内置页面'
}

export const PAGE_STATUS = ['draft', 'published']

export const WTPP_APPLICATION_PRINCIPAL_TYPE = {
  person: '个人',
  enterprise: '企业',
  media: '媒体',
  government: '政府',
  other: '其他'
}

export const SUBMITION_STATE = {
  pending: '审核中',
  success: '审核通过',
  fail: '审核不通过',
  delay: '审核延后'
}

export const WECHAT_CATEGORY_AUDIT_STATUSES = {
  1: '审核中',
  2: '审核不通过',
  3: '审核通过'
}

export const CONTENT_TYPES = [
  'image',
  'video',
  'audio',
  'text',
  'xml',
  'json',
  'pdf',
  'sheet'
]

export const MEMBER_USER_TYPES = ['amateur', 'practitioner']

export const BANNER_PAGE_POSITIONS = [
  'event'
]

export const BANNER_KINDS = [
  'web_link',
  'image',
  'mp_link'
]

export const QUESTION_KINDS = ['single_choice', 'multiple_choice']

export const POST_PUBLISHER_TYPE = [
  'Application',
  'Merchant'
]
